"use client";


import clsx from "clsx";
import PricingOfferButton from "~/app/[locale]/pricing/components/PricingOfferButton";

import { useTranslation } from "~/app/hooks/useTranslation";
import Img1Tr from "~/assets/images/marketing/chat-tr.png";
import Img1 from "~/assets/images/marketing/chat.png";
import Breadcrumb from "~/common/components/Breadcrumb";
import Image from "~/common/components/CustomImage";
import SectionWrapper from "~/common/components/SectionWrapper";

import styles from "./SectionBook.module.scss";

export default function SectionBook({ locale, title, description }) {
  const { t } = useTranslation(locale);
  return (
    <SectionWrapper background={"/marketing/heroBook.jpg"} className={styles.section}>
      <div className={clsx(styles.breadcrumb, "card")}>
        <Breadcrumb
          segments={[
            t("solutions.breadcrumb.solutions"),
            t("solutions.breadcrumb.byIndustry"),
            t("solutions.breadcrumb.marketing"),
          ]}
        />
      </div>
      <div className={clsx(styles.container, "card")}>
        <div className={styles.content}>
          <p className={styles.pageName}>{t("solutions.breadcrumb.marketing")}</p>
          <h1 className={clsx("pal-section-title", styles.title)} title={title ?? t("solutions.marketing.sectionBook.title")}>{title ?? t("solutions.marketing.sectionBook.title")}</h1>
          <p className={clsx("pal-section-desc", styles.desc)}>{description ?? t("solutions.marketing.sectionBook.description")}</p>
          <div className={styles.inputWrapper}>
            <PricingOfferButton className="pill pink" source="marketing-section-book" />
          </div>
        </div>
        <div className={styles.image}>
          <Image
            src={locale === "tr" ? Img1Tr : Img1}
            alt={t("solutions.marketing.sectionBook.imageAlt")}
            width={Img1.width}
            height={Img1.height}
          />
        </div>
      </div>
    </SectionWrapper>
  );
}
